/**
 * @class mApp  Metronic App class
 */

import { mPortlet } from "../components/general/portlet";
import { KTPasswordMeter } from "../components/general/password-meter";
import { initMenu } from "../components/general/menu";
import { initDropdown } from "../components/general/dropdown";

export const mApp = function () {

    /** @type {object} colors State colors **/
    var colors = {
        brand: '#36a3f7',
        metal: '#c4c5d6',
        light: '#ffffff',
        accent: '#00c5dc',
        primary: '#5867dd',
        success: '#34bfa3',
        info: '#36a3f7',
        warning: '#ffb822',
        danger: '#f4516c',
        focus: '#9816f4'
    }

    /**
    * Initializes bootstrap tooltip
    */
    var initTooltip = function (el) {
        var skin = el.data('skin') ? 'm-tooltip--skin-' + el.data('skin') : '';
        var width = el.data('width') == 'auto' ? 'm-tooltop--auto-width' : '';
        var triggerValue = el.data('trigger') ? el.data('trigger') : 'hover';

        el.tooltip({
            trigger: triggerValue,
            template: '<div class="m-tooltip ' + skin + ' ' + width + ' tooltip" role="tooltip">\
                <div class="arrow"></div>\
                <div class="tooltip-inner"></div>\
            </div>'
        });
    }

    /**
    * Initializes bootstrap tooltips
    */
    var initTooltips = function () {
        // init bootstrap tooltips
        $('[data-toggle="m-tooltip"]').each(function () {
            initTooltip($(this));
        });
    }

    /**
    * Initializes bootstrap popover
    */
    var initPopover = function (el) {
        var skin = el.data('skin') ? 'm-popover--skin-' + el.data('skin') : '';

        if (el.data('popover-toggle')) {
            var triggerValue = el.data('popover-trigger') ? el.data('popover-trigger') : 'hover';
            var placementValue = el.data('popover-placement') ? el.data('popover-placement') : 'auto';
            var containerValue = el.data('popover-container') ? el.data('popover-container') : false;
        } else {
            var triggerValue = el.data('trigger') ? el.data('trigger') : 'hover';
            var placementValue = el.data('placement') ? el.data('placement') : 'auto';
            var containerValue = el.data('container') ? el.data('container') : false;
        }

        el.popover({
            trigger: triggerValue,
            placement: placementValue,
            container: containerValue,
            template: '\
            <div class="m-popover ' + skin + ' popover" role="tooltip">\
                <div class="arrow"></div>\
                <h3 class="popover-header border-bottom"></h3>\
                <div class="popover-body"></div>\
            </div>'
        });

        el.popover('hide');
    }

    /**
    * Initializes bootstrap popovers
    */
    var initPopovers = function () {
        // init bootstrap popover
        $('[data-toggle="m-popover"],[data-popover-toggle="m-popover"]').each(function () {
            initPopover($(this));
        });
    }

    /**
    * Initializes bootstrap file input
    */
    var initFileInput = function () {
        // init bootstrap popover
        $('.custom-file-input').on('change', function () {
            var fileName = $(this).val();
            $(this).next('.custom-file-label').addClass("selected").html(fileName);
        });
    }

    /**
    * Initializes metronic portlet
    */
    var initPortlet = function (el, options) {
        // init portlet tools
        var el = $(el);
        var portlet = new mPortlet(el[0], options);
    }

    /**
    * Initializes metronic portlets
    */
    var initPortlets = function () {
        // init portlet tools
        $('[m-portlet="true"]').each(function () {
            var el = $(this);

            if (el.data('portlet-initialized') !== true) {
                initPortlet(el, {});
                el.data('portlet-initialized', true);
            }
        });
    }

    /**
    * Initializes bootstrap-select
    */
    var initBootstrapSelects = function () {
        // init bootstrap-select
        $('.m_selectpicker').each(function () {
            var el = $(this);

            el.selectpicker();
        });
    }

    /**
    * Initializes scrollable contents
    */
    var initScrollers = function () {
        $('[data-scrollable="true"]').each(function () {
            var el = $(this);
            mUtil.scrollerInit(this, {
                disableForMobile: true, handleWindowResize: true, height: function () {
                    if (mUtil.isInResponsiveRange('tablet-and-mobile') && el.data('mobile-height')) {
                        return el.data('mobile-height');
                    } else {
                        return el.data('height');
                    }
                }
            });
        });
    }

    /**
    * Initializes bootstrap alerts
    */
    var initAlerts = function () {
        // init bootstrap popover
        $('body').on('click', '[data-close=alert]', function () {
            $(this).closest('.alert').hide();
        });
    }

    /**
    * Initializes Metronic custom tabs
    */
    var initCustomTabs = function () {
        // init bootstrap popover
        $('[data-tab-target]').each(function () {
            if ($(this).data('tabs-initialized') == true) {
                return;
            }

            $(this).click(function (e) {
                e.preventDefault();

                var tab = $(this);
                var tabs = tab.closest('[data-tabs="true"]');
                var contents = $(tabs.data('tabs-contents'));
                var content = $(tab.data('tab-target'));

                tabs.find('.m-tabs__item.m-tabs__item--active').removeClass('m-tabs__item--active');
                tab.addClass('m-tabs__item--active');

                contents.find('.m-tabs-content__item.m-tabs-content__item--active').removeClass('m-tabs-content__item--active');
                content.addClass('m-tabs-content__item--active');
            });

            $(this).data('tabs-initialized', true);
        });
    }

    /**
    * Initializes KTPasswordMeter
    */
    var initKTPasswordMeter = function () {
        var elements = document.body.querySelectorAll('[data-kt-password-meter]');

        if ( elements && elements.length > 0 ) {
            for (var i = 0, len = elements.length; i < len; i++) {
                // Initialize instances
                new KTPasswordMeter(elements[i]);
            }            
        }
    }    

    var hideTouchWarning = function () {
        jQuery.event.special.touchstart = {
            setup: function (_, ns, handle) {
                if (typeof this === 'function')
                    if (ns.includes('noPreventDefault')) {
                        this.addEventListener('touchstart', handle, { passive: false });
                    } else {
                        this.addEventListener('touchstart', handle, { passive: true });
                    }
            },
        };
        jQuery.event.special.touchmove = {
            setup: function (_, ns, handle) {
                if (typeof this === 'function')
                    if (ns.includes('noPreventDefault')) {
                        this.addEventListener('touchmove', handle, { passive: false });
                    } else {
                        this.addEventListener('touchmove', handle, { passive: true });
                    }
            },
        };
        jQuery.event.special.wheel = {
            setup: function (_, ns, handle) {
                if (typeof this === 'function')
                    if (ns.includes('noPreventDefault')) {
                        this.addEventListener('wheel', handle, { passive: false });
                    } else {
                        this.addEventListener('wheel', handle, { passive: true });
                    }
            },
        };
    };

    return {
        /**
        * Main class initializer
        */
        init: function (options) {
            if (options && options.colors) {
                colors = options.colors;
            }
            mApp.initComponents();
        },

        /**
        * Initializes components
        */
        initComponents: function () {
            hideTouchWarning();
            initScrollers();
            initTooltips();
            initPopovers();
            initAlerts();
            initPortlets();
            initFileInput();
            initCustomTabs();
            initBootstrapSelects();
            initKTPasswordMeter();
            initMenu();
            initDropdown();
        },


        /**
        * Init custom tabs
        */
        initCustomTabs: function () {
            initCustomTabs();
        },

        /**
        * Init bootstrap selects
        */
        initBootstrapSelects: function () {
            initBootstrapSelects();
        },

        /**
        *
        * @param {object} el jQuery element object
        */
        // wrJangoer function to scroll(focus) to an element
        initTooltips: function () {
            initTooltips();
        },

        /**
        *
        * @param {object} el jQuery element object
        */
        // wrJangoer function to scroll(focus) to an element
        initTooltip: function (el) {
            initTooltip(el);
        },

        /**
        *
        * @param {object} el jQuery element object
        */
        // wrJangoer function to scroll(focus) to an element
        initPopovers: function () {
            initPopovers();
        },

        /**
        *
        * @param {object} el jQuery element object
        */
        // wrJangoer function to scroll(focus) to an element
        initPopover: function (el) {
            initPopover(el);
        },

        /**
        *
        * @param {object} el jQuery element object
        */
        // function to init portlet
        initPortlet: function (el, options) {
            initPortlet(el, options);
        },

        /**
        *
        * @param {object} el jQuery element object
        */
        // function to init portlets
        initPortlets: function () {
            initPortlets();
        },

        /**
        * Blocks element with loading indiciator using http://malsup.com/jquery/block/
        * @param {object} target jQuery element object
        * @param {object} options
        */
        block: function (target, options) {
            var el = $(target);

            options = $.extend(true, {
                opacity: 0.03,
                overlayColor: '#000000',
                state: 'brand',
                type: 'loader',
                size: 'lg',
                centerX: true,
                centerY: true,
                message: '',
                shadow: true,
                width: 'auto'
            }, options);

            var skin;
            var state;
            var loading;

            if (options.type == 'spinner') {
                skin = options.skin ? 'm-spinner--skin-' + options.skin : '';
                state = options.state ? 'm-spinner--' + options.state : '';
                loading = '<div class="m-spinner ' + skin + ' ' + state + '"></div';
            } else {
                skin = options.skin ? 'm-loader--skin-' + options.skin : '';
                state = options.state ? 'm-loader--' + options.state : '';
                size = options.size ? 'm-loader--' + options.size : '';
                loading = '<div class="m-loader ' + skin + ' ' + state + ' ' + size + '"></div';
            }

            if (options.message && options.message.length > 0) {
                var classes = 'm-blockui ' + (options.shadow === false ? 'm-blockui-no-shadow' : '');

                html = '<div class="' + classes + '"><span>' + options.message + '</span><span>' + loading + '</span></div>';

                var el = document.createElement('div');
                mUtil.get('body').prepend(el);
                mUtil.addClass(el, classes);
                el.innerHTML = '<span>' + options.message + '</span><span>' + loading + '</span>';
                options.width = mUtil.actualWidth(el) + 10;
                mUtil.remove(el);

                if (target == 'body') {
                    html = '<div class="' + classes + '" style="margin-left:-' + (options.width / 2) + 'px;"><span>' + options.message + '</span><span>' + loading + '</span></div>';
                }
            } else {
                html = loading;
            }

            var params = {
                message: html,
                centerY: options.centerY,
                centerX: options.centerX,
                css: {
                    top: '30%',
                    left: '50%',
                    border: '0',
                    padding: '0',
                    backgroundColor: 'none',
                    width: options.width
                },
                overlayCSS: {
                    backgroundColor: options.overlayColor,
                    opacity: options.opacity,
                    cursor: 'wait',
                    zIndex: '10'
                },
                onUnblock: function () {
                    if (el) {
                        mUtil.css(el, 'position', '');
                        mUtil.css(el, 'zoom', '');
                    }
                }
            };

            if (target == 'body') {
                params.css.top = '50%';
                $.blockUI(params);
            } else {
                var el = $(target);
                el.block(params);
            }
        },

        /**
        * Un-blocks the blocked element
        * @param {object} target jQuery element object
        */
        unblock: function (target) {
            if (target && target != 'body') {
                $(target).unblock();
            } else {
                $.unblockUI();
            }
        },

        /**
        * Blocks the page body element with loading indicator
        * @param {object} options
        */
        blockPage: function (options) {
            return mApp.block('body', options);
        },

        /**
        * Un-blocks the blocked page body element
        */
        unblockPage: function () {
            return mApp.unblock('body');
        },

        /**
        * Enable loader progress for button and other elements
        * @param {object} target jQuery element object
        * @param {object} options
        */
        progress: function (target, options) {
            var skin = (options && options.skin) ? options.skin : 'light';
            var alignment = (options && options.alignment) ? options.alignment : 'right';
            var size = (options && options.size) ? 'm-spinner--' + options.size : '';
            var classes = 'm-loader ' + 'm-loader--' + skin + ' m-loader--' + alignment + ' m-loader--' + size;

            mApp.unprogress(target);

            $(target).addClass(classes);
            $(target).data('progress-classes', classes);
        },

        /**
        * Disable loader progress for button and other elements
        * @param {object} target jQuery element object
        */
        unprogress: function (target) {
            $(target).removeClass($(target).data('progress-classes'));
        },

        /**
        * Gets state color's hex code by color name
        * @param {string} name Color name
        * @returns {string}
        */
        getColor: function (name) {
            return colors[name];
        }
    };
}();